'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liveSubscription = exports.redeemSubscriptionCode = exports.userSubscription = exports.subscription = exports.createLiveSubscription = exports.createSubscription = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sagaTools = require('@classpass/saga-tools');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IMMEDIATELY = 'immediately';

var createSubscription = exports.createSubscription = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CREATE_SUBSCRIPTION', function (client, _ref) {
  var consents = _ref.consents,
      conversion = _ref.conversion,
      effective = _ref.effective,
      giftCode = _ref.giftCode,
      livePlanId = _ref.livePlanId,
      locationId = _ref.locationId,
      msaId = _ref.msaId,
      planId = _ref.planId,
      stripeToken = _ref.stripeToken,
      userId = _ref.userId;

  var payload = (0, _extends3.default)({
    effective: effective || IMMEDIATELY,
    msa_id: parseInt(msaId, 10),
    plan_id: planId
  }, consents && { consents: consents }, conversion && !(0, _verify.isEmpty)(conversion) && { conversion: conversion }, giftCode && { redemption_code: giftCode }, livePlanId && { digital_plan_id: livePlanId }, locationId && { gls_location_id: locationId }, stripeToken && { payment_token: stripeToken });

  return client.subscription.create(userId, payload);
});

var createLiveSubscription = exports.createLiveSubscription = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CREATE_LIVE_SUBSCRIPTION', function (client, payload) {
  return client.subscription.createLive(payload);
});

// we need to dedupe these two.
var subscription = exports.subscription = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SUBSCRIPTION', function (client, userId) {
  return client.subscription.getV2(userId).then(function (data) {
    return data.data;
  });
});

var userSubscription = exports.userSubscription = (0, _sagaTools.makeEntityScaffold)('SAGA.API.USER_SUBSCRIPTION', function (client, userId) {
  return client.subscription.getV2(userId).then(function (data) {
    return data.data;
  });
}, { defaultKey: 1 });

var redeemSubscriptionCode = exports.redeemSubscriptionCode = (0, _sagaTools.makeEntityScaffold)('SAGA.API.REDEEM_SUBSCRIPTION_CREDIT', function (client, userId, code) {
  return client.subscription.redeem(userId, {
    redemption_code: code
  });
}, { defaultKey: 1 });

var liveSubscription = exports.liveSubscription = (0, _sagaTools.makeEntityScaffold)('SAGA.API.LIVE_SUBSCRIPTION', function (client) {
  return client.subscription.getLive();
});